import { createSlice } from "@reduxjs/toolkit";

const contentSlice = createSlice({
  name: "content",
  initialState: {
    pages: null,
    media: {},
    settings: {}
  },
  reducers: {
    savePages: (state, action) => {
      state.pages = action.payload;
    },
    saveMedia: (state, action) => {
      state.media = action.payload;
    },
    saveSettings: (state, action) => {
      state.settings = action.payload;
    }
  }
});

export const { savePages, saveMedia, saveSettings } = contentSlice.actions;
export default contentSlice.reducer;
